var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0631 3.16669C16.9911 3.15928 16.9186 3.15928 16.8467 3.16669H2.06891C1.97419 3.16815 1.88011 3.18235 1.78918 3.20891L9.41557 10.8036L17.0631 3.16669Z",
    fill: "#572148"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8442 3.90015L10.1598 11.5529C9.96202 11.7495 9.69448 11.8599 9.41562 11.8599C9.13676 11.8599 8.86923 11.7495 8.67145 11.5529L1.05562 3.9582C1.03221 4.04425 1.01979 4.13292 1.01868 4.22209V14.7776C1.01868 15.0576 1.12989 15.3261 1.32784 15.524C1.5258 15.722 1.79428 15.8332 2.07423 15.8332H16.852C17.132 15.8332 17.4004 15.722 17.5984 15.524C17.7964 15.3261 17.9076 15.0576 17.9076 14.7776V4.22209C17.9034 4.11213 17.882 4.0035 17.8442 3.90015ZM2.79729 14.7776H2.06368V14.0229L5.90062 10.2176L6.64479 10.9618L2.79729 14.7776ZM16.8415 14.7776H16.1026L12.2551 10.9618L12.9992 10.2176L16.8362 14.0229L16.8415 14.7776Z",
    fill: "#572148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.688dcb2614d3f7920221a65aed62215b.svg";
export { ForwardRef as ReactComponent };